import { Dropdown, NavigationLink, Text } from '@ui/themed';
import { t } from 'i18next';
import type { DropdownOption } from '../../../../components/ui/dropdown/types';
import { useHandlers } from '../../../../context/page-context';
import { PRICE_LIST_SOURCES, type PriceList, useAllPriceLists } from '../../../price-lists';
import { useCustomerGroupsQuickSetupForm } from '../../hooks/use-customer-groups-quick-setup-form';

function transformPriceListOptions(priceLists: PriceList[]): DropdownOption[] {
  return priceLists
    .filter((pl) => pl.source !== PRICE_LIST_SOURCES.PLATFORM)
    .map(
      (pl): DropdownOption => ({
        value: pl.slug,
        label: `${pl.currency_code.toUpperCase()} - ${pl.name}`,
      }),
    );
}

export function AssignedPriceListField() {
  const { navigationHandler } = useHandlers();
  const form = useCustomerGroupsQuickSetupForm();
  const { data: priceLists } = useAllPriceLists();
  const priceListOptions = transformPriceListOptions(priceLists);

  return (
    <form.Field name="assignedPriceList">
      {(field) => (
        <div className="flex flex-col gap-1">
          <Dropdown
            label={t('features:customer_group.components.quick_setup.assigned_price_list.label')}
            options={priceListOptions}
            value={field.state.value}
            onChange={(value) => {
              field.handleChange(value);

              const selectedPriceList = priceLists.find((pl) => pl.slug === value);
              if (selectedPriceList) {
                form.setFieldValue('baseCurrency', selectedPriceList.currency_code);
              }
            }}
            disabled={priceListOptions.length === 0}
            placeholder={
              priceListOptions.length === 0
                ? t(
                    'features:customer_group.components.quick_setup.assigned_price_list.no_price_lists_placeholder',
                  )
                : t('features:customer_group.components.price_lists_card.select.placeholder')
            }
            error={field.state.meta.errors[0]?.message}
          />

          <Text variant="secondary">
            {t('features:customer_group.components.quick_setup.assigned_price_list.hint')}{' '}
            <NavigationLink
              onClick={() => navigationHandler.navigate('/pricing/lists', { newTab: true })}
            >
              {t('features:customer_group.pages.customer_groups_quick_setup_page.view_price_lists')}
            </NavigationLink>
          </Text>
        </div>
      )}
    </form.Field>
  );
}
